import { useMemo } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDDropzone from "components/MDDropzone";

export default function AttachmentsField({files, setFiles}) {

    // File upload handler
    const filesHandler = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            setFiles(prev => ({
            ...prev,
            [file.upload.filename]: e.target.result
            }));
        };
        reader.readAsDataURL(file);
    }

    return (
        <MDBox>
            <MDBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                    Attachments
                </MDTypography>
            </MDBox>
            {useMemo(
                () => (
                    <MDDropzone
                        options={{
                            addRemoveLinks: true,
                            disablePreviews: false
                        }}
                        onFileAdd={filesHandler}
                    />
                ),
                []
            )}
        </MDBox>
    );
}